import React from "react";
import ReactSwitch from "react-switch";

interface SwitchInputProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const SwitchInput: React.FC<SwitchInputProps> = (props: SwitchInputProps) => {
  const { onChange, checked, disabled } = props;

  return (
    <ReactSwitch
      onChange={onChange}
      checked={checked}
      disabled={disabled}
      checkedIcon={false}
      uncheckedIcon={false}
      handleDiameter={15}
      height={19}
      width={32}
      onColor="#007aff"
      offColor="#bec3c7"
    />
  );
};

export default SwitchInput;
